import { createColumn, getSortOptions } from "@repo/mfe-core";
import type { IntlShape } from "react-intl";

export const tableColumns = [
  createColumn("name", "Name", "25rem", { isPinned: true }),
  createColumn("type", "Type", "10rem"),
  createColumn("created_date", "Created On", "10rem"),
];

const sortableColumns = ["name", "type", "created_date"];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));
